"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Evolve static docs links
const evolveLinks = {
    termsOfEngagementUrl: "https://doc.rota.com/evolve/agency-worker-agreement-nov-2022.pdf",
    keyInformationDocumentUrl: "https://doc.rota.com/evolve/key-information-document-nov-2022.pdf",
    medicalStatementUrl: "https://doc.rota.com/evolve/medical-statement.pdf",
    uniformStatementUrl: "https://doc.rota.com/evolve/uniform-statement.pdf",
    GDPRConsentFormUrl: "https://doc.rota.com/evolve/gdpr-consent.pdf",
};
exports.default = evolveLinks;
